var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropdownIterativeUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.293 7.29289L4.29297 14.2929L5.70718 15.7071L12.0001 9.41421L18.293 15.7071L19.7072 14.2929L12.7072 7.29289C12.3167 6.90237 11.6835 6.90237 11.293 7.29289Z",
  fill: "#767676"
})));
export { SvgDropdownIterativeUp as ReactComponent };
export default __webpack_public_path__ + "assets/a153a8ec.svg";